import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import SearchNoResult from "./_search_no_result";
import SearchResult from "./_search_results";

const useStyles = makeStyles((theme) => ({
  marginContent: {
    marginTop: "1%",
  },
}));

export default function SearchContent({ searchResult, sloading, searchContent, contentReady }) {
  const classes = useStyles();
  return (
    <Grid
      container
      className={classes.marginContent}
      direction={searchResult?.hits?.total?.value ? "row" : "column"}
    >
      <Grid item xs={12}>
        {sloading ? (
          <Skeleton />
        ) : searchResult?.hits?.total?.value ? (
          <SearchResult searchResult={searchResult} searchContent={searchContent} contentReady={contentReady}/>
        ) : (
          <SearchNoResult searchContent={searchContent} contentReady={contentReady} />
        )}
      </Grid>
    </Grid>
  );
}
